import { Outlet } from 'react-router-dom';

import { DifferentialModeProvider } from 'lib/hooks';

export const SitesPageLayout = () => (
    <DifferentialModeProvider>
        <Outlet />
    </DifferentialModeProvider>
);
